export default "__VITE_ASSET__DeBtfSuK__"